/**
 * Creates a console logger that increments a counter each time it's called
 * @param label Optional label to identify the source of the logs
 * @returns A function that logs with an incrementing counter
 */
export const createCountLogger = (label = 'Render') => {
  let count = 0;
  let lastCalled = Date.now();

  return (...args: unknown[]) => {
    count++;
    const now = Date.now();
    const timeSinceLast = now - lastCalled;
    lastCalled = now;

    console.log(
      `%c[${label}] %ccount: ${count} (${timeSinceLast}ms since last call)`,
      'color: red; font-weight: bold',
      'color: blue',
      ...args
    );
    return count;
  };
};
